const Reset = ({ size = 20, color = 'currentColor', ...other }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <path
        d="M5.75413 3.14911C3.64229 4.41804 2.30625 6.48622 1.90047 8.73415L3.32078 8.95861C3.66204 7.11581 4.76174 5.42244 6.4945 4.38129C9.48842 2.58236 13.3143 3.36629 15.3785 6.08645L12.7949 5.67738L12.5701 7.09718L16.6266 7.73968L16.7294 7.74948C17.1374 7.76277 17.501 7.47047 17.5665 7.05687L18.209 3.00029L16.7892 2.77541L16.4233 5.08766C13.8992 1.89446 9.33561 0.997147 5.75413 3.14911ZM3.26268 12.2896C2.85471 12.2763 2.49115 12.5686 2.42564 12.9822L1.78314 17.0388L3.20294 17.2637L3.56881 14.9514C6.09286 18.1446 10.6565 19.0419 14.238 16.89C16.3516 15.62 17.6881 13.5494 18.0927 11.2993L16.6725 11.0743C16.3325 12.9195 15.2323 14.6155 13.4976 15.6578C10.5037 17.4567 6.67784 16.6728 4.61355 13.9526L7.19716 14.3617L7.42203 12.9419L3.36546 12.2994L3.26268 12.2896Z"
        fill={color}
      />
    </svg>
  );
};

export default Reset;
